var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{staticClass:"banner-img",attrs:{"src":_vm.data.img}}),_c('p',{staticClass:"banner-title-ch"},[_vm._v(_vm._s(_vm.data.titleCh))]),_c('p',{staticClass:"banner-title-en"},[_vm._v(_vm._s(_vm.data.titleEn))])])
}
var staticRenderFns = []

export { render, staticRenderFns }